import useSWR from 'swr'
import { requestWithCache } from 'lib/api'
import { ENDPOINTS } from 'lib/api/const'

function useBestsellers(categoryId, limit = 3) {
  const bestsellerParams = {
    params: {
      limit,
    },
  }

  const { data, error, mutate, isValidating } = useSWR(
    [ENDPOINTS.bestsellers.link(categoryId), JSON.stringify(bestsellerParams)],
    requestWithCache,
    {
      dedupingInterval: ENDPOINTS.bestsellers.cache,
    },
  )

  return {
    data: data?.products,
    error,
    isLoading: data === undefined && !error,
    isValidating,
    retry: mutate,
  }
}

export default useBestsellers
